import React, { ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTokenCheck } from "../hooks/useTokenCheck";


const AuthWrapper = ({ children }: { children: ReactNode }) => {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();

  const { error, refetch } = useTokenCheck();

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    const interval = setInterval(() => {
      refetch();
    }, 5 * 60 * 1000);

  
    return () => clearInterval(interval);
  }, [token, refetch, navigate]);

  
  useEffect(() => {
    if (error) {
      localStorage.removeItem("token"); 
      navigate("/login");
    }
  }, [error, navigate]);

  
  if (!token) {
    return null;
  }

  return <div>{children}</div>;
};

export default AuthWrapper;